const metals = {
  XAU: {
    code: 'XAU',
    name: 'Gold',
    image: 'https://s3-symbol-logo.tradingview.com/metal/gold.svg'
  },
  XAG: {
    code: 'XAG',
    name: 'Silver',
    image: 'https://s3-symbol-logo.tradingview.com/metal/silver.svg'
  },
  XPT: {
    code: 'XPT',
    name: 'Platinum',
    image: 'https://s3-symbol-logo.tradingview.com/metal/platinum.svg'
  },
  XPD: {
    code: 'XPD',
    name: 'Palladium',
    image: 'https://s3-symbol-logo.tradingview.com/metal/palladium.svg'
  }
};

const currencies = {
  USD: {
    code: 'USD',
    name: 'US Dollar'
  },
  AUD: {
    code: 'AUD',
    name: 'Australian Dollar'
  },
  GBP: {
    code: 'GBP',
    name: 'British Pound'
  },
  EUR: {
    code: 'EUR',
    name: 'Euro'
  },
  CHF: {
    code: 'CHF',
    name: 'Swiss Franc'
  },
  CAD: {
    code: 'CAD',
    name: 'Canadian Dollar'
  },
  JPY: {
    code: 'JPY',
    name: 'Japanese Yen'
  },
  KRW: {
    code: 'KRW',
    name: 'South Korean Won'
  },
  INR: {
    code: 'INR',
    name: 'Indian Rupee'
  },
  CNY: {
    code: 'CNY',
    name: 'Chinese Yuan'
  },
  ZAR: {
    code: 'ZAR',
    name: 'South African Rand'
  },
  SGD: {
    code: 'SGD',
    name: 'Singapore Dollar'
  },
  BTC: {
    code: 'BTC',
    name: 'Bitcoin'
  },
  HKD: {
    code: 'HKD',
    name: 'Hong Kong Dollar'
  },
  THB: {
    code: 'THB',
    name: 'Thai Baht'
  },
  CZK: {
    code: 'CZK',
    name: 'Czech Koruna'
  },
  RUB: {
    code: 'RUB',
    name: 'Russian Ruble'
  },
  PLN: {
    code: 'PLN',
    name: 'Polish Zloty'
  },
  MYR: {
    code: 'MYR',
    name: 'Malaysian Ringgit'
  },
  AED: {
    code: 'AED',
    name: 'UAE Dirham'
  },
  KWD: {
    code: 'KWD',
    name: 'Kuwaiti Dinar'
  },
  EGP: {
    code: 'EGP',
    name: 'Egyptian Pound'
  },
  OMR: {
    code: 'OMR',
    name: 'Omani Rial'
  },
  SAR: {
    code: 'SAR',
    name: 'Saudi Riyal'
  },
  MXN: {
    code: 'MXN',
    name: 'Mexican Peso'
  },
  JOD: {
    code: 'JOD',
    name: 'Jordanian Dinar'
  }
};

const modifiers = {
  live: {
    slug: 'live',
    label: 'Live Price'
  },
  historical: {
    slug: 'historical',
    label: 'Historical Price'
  },
  free: {
    slug: 'free',
    label: 'Free API'
  },
  json: {
    slug: 'json',
    label: 'JSON Response'
  },
  python: {
    slug: 'python',
    label: 'Python'
  },
  js: {
    slug: 'js',
    label: 'JavaScript'
  },
  javascript: {
    slug: 'javascript',
    label: 'JavaScript'
  },
  curl: {
    slug: 'curl',
    label: 'Curl'
  },
  ts: {
    slug: 'ts',
    label: 'TypeScript'
  },
  node: {
    slug: 'node',
    label: 'Node.js'
  },
  php: {
    slug: 'php',
    label: 'PHP'
  },
  cs: {
    slug: 'cs',
    label: 'C#'
  },
  go: {
    slug: 'go',
    label: 'Go'
  },
  java: {
    slug: 'java',
    label: 'Java'
  },
  'per-gram': {
    slug: 'per-gram',
    label: 'Per Gram'
  },
  'per-ounce': {
    slug: 'per-ounce',
    label: 'Per Ounce'
  },
  'per-kg': {
    slug: 'per-kg',
    label: 'Per Kilogram'
  },
  '24-karats': {
    slug: '24-karats',
    label: '24 Karats'
  },
  '22-karats': {
    slug: '22-karats',
    label: '22 Karats'
  },
  '21-karats': {
    slug: '21-karats',
    label: '21 Karats'
  },
  '20-karats': {
    slug: '20-karats',
    label: '20 Karats'
  },
  '18-karats': {
    slug: '18-karats',
    label: '18 Karats'
  },
  '16-karats': {
    slug: '16-karats',
    label: '16 Karats'
  },
  '14-karats': {
    slug: '14-karats',
    label: '14 Karats'
  },
  '10-karats': {
    slug: '10-karats',
    label: '10 Karats'
  }
};

export { metals, currencies, modifiers };
